// extracted by mini-css-extract-plugin
export default {"filters":"SimCardsScreen_filters__cIaqr"};